import {
  getTickets,
  openModalSuccessCreate,
} from '../../redux/actions/TicketActions';
import { messageSelfServiceMapper } from './SelfService';
import { PURCHASE_ROUTE } from '../../constants/Routes';

const useSetMessage = (selfServiceStatus, data, dispatch, history) => {
  if (selfServiceStatus === 'succeded' && Object.keys(data).length > 0) {
    dispatch(getTickets());
    dispatch(
      openModalSuccessCreate({
        motiveId: data.motiveId,
        changeMessage: messageSelfServiceMapper.get(data.motiveId),
        newValue: data.message,
        noProduct: data.noProduct,
      }),
    );
    history.push(PURCHASE_ROUTE);
  }
};

export default useSetMessage;
